import React, { Component } from 'react';
import { Container, Row, Col, Card, CardBody, Button } from 'reactstrap';
import { connect } from 'react-redux';

const mapStateToProps = state => ({
    ...state.register,
    appName: state.common.appName
});

const mapDispatchToProps = dispatch => ({

});

class RegisterThanks extends Component {
    render() {
        return (
            <div className="app flex-row align-items-center">
                <Container>
                    <Row className="justify-content-center">
                        <Col md="6">
                            <Card className="mx-4">
                                <CardBody className="p-4">
                                    <h1>Register</h1>
                                    <p className="text-muted">Registration complete.</p>


                                    <Button color="success" block href="/">Return To Home</Button>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(RegisterThanks);


// WEBPACK FOOTER //
// ./src/containers/ForgotLoginThanks.js